var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPahIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4872 10.2702C13.4872 9.55403 14.0678 8.97344 14.784 8.97344H16.8465C16.9503 8.97344 17.0343 9.05752 17.0343 9.16124V11.3792C17.0343 11.4829 16.9503 11.567 16.8465 11.567H14.784C14.0678 11.567 13.4872 10.9864 13.4872 10.2702Z",
    fill: "#57EBA4",
    stroke: "#303030",
    strokeWidth: 0.74375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2146 8.85266V7.18399C16.2146 6.65738 15.7876 6.23047 15.261 6.23047H1.95377C1.42715 6.23047 1.00024 6.65738 1.00024 7.18399V14.1111C1.00024 14.6377 1.42715 15.0646 1.95377 15.0646H15.261C15.7876 15.0646 16.2146 14.6377 16.2146 14.1111V11.7132",
    stroke: "#303030",
    strokeWidth: 0.74375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71231 3.55734L5.92212 6.22947H11.2086L11.5576 5.4752C11.6069 5.36858 11.5712 5.24192 11.4735 5.17675L11.3527 5.09627C11.0875 4.91942 10.9281 4.6217 10.9281 4.30289V4.007C10.9281 3.91671 10.8771 3.83417 10.7964 3.79379L9.65152 3.22137C9.55974 3.17548 9.4489 3.19347 9.37635 3.26602L9.26866 3.37371C8.97845 3.66392 8.53509 3.73587 8.16799 3.55232L8.01696 3.47681C7.90962 3.42314 7.77911 3.45764 7.71231 3.55734Z",
    fill: "#57EBA4",
    stroke: "#303030",
    strokeWidth: 0.715144
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64648 6.10417L7.60172 1.36575C7.73124 1.15807 7.99699 1.0822 8.21664 1.19021L13.3304 3.70488C13.5678 3.82162 13.6647 4.10932 13.5464 4.34593L12.6673 6.10417",
    stroke: "#303030",
    strokeWidth: 0.715144
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPahIcon);
export default __webpack_public_path__ + "static/media/PAHIcon.a830c6aacee8f0c43b596006f93d32b2.svg";
export { ForwardRef as ReactComponent };